import { Module } from "vuex";
import { RootState } from "../types";
import { BundleCourseState } from "./types";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";

export const state: BundleCourseState = {};

const namespaced: boolean = true;

export const bundleCourse: Module<BundleCourseState, RootState> = {
  namespaced,
  state,
  actions,
  getters,
  mutations,
};
